import { ApplicationTypes, attachComponent } from 'jms-domain'

import { memoEval, propertyPageComponent } from '@salsita-ai/platform-project-sdk/domain'

import { AdjustableDoorWallItemPropertyPage } from '../ui/property-pages/AdjustableDoorWallItemPropertyPage'
import { BurnerBasePropertyPage } from '../ui/property-pages/BurnerBasePropertyPage'
import { GrillBasePropertyPage } from '../ui/property-pages/GrillBasePropertyPage'

export const cabinetComponents = [
  attachComponent
    .withComponent(propertyPageComponent, 'grillPage')
    .withEntity('GrillBase')
    .withFilter(s => ({
      navigationStates: [ApplicationTypes.NavigationState.RoomContent, ApplicationTypes.NavigationState.Recipes],
      selectedEntityIds: [s.id],
    }))
    .attach(
      memoEval(
        s => [s.id, s.applianceId, s.warmingDrawerId],
        (id, applianceId, warmingDrawerId) => ({
          page: <GrillBasePropertyPage cabinetId={id} applianceId={applianceId} warmingDrawerId={warmingDrawerId} />,
        })
      )
    ),

  attachComponent
    .withComponent(propertyPageComponent, 'burnerPage')
    .withAlias('BurnerBase')
    .withFilter(s => ({
      navigationStates: [ApplicationTypes.NavigationState.RoomContent, ApplicationTypes.NavigationState.Recipes],
      selectedEntityIds: [s.id],
    }))
    .attach(
      memoEval(
        s => [s.id, s.applianceId],
        (id, applianceId) => ({
          page: applianceId ? <BurnerBasePropertyPage id={id} applianceId={applianceId} /> : null,
        })
      )
    ),

  attachComponent
    .withComponent(propertyPageComponent, 'doorPage')
    .withAlias('AdjustableDoorCabinet')
    .withFilter(s => ({
      navigationStates: [ApplicationTypes.NavigationState.RoomContent, ApplicationTypes.NavigationState.Recipes],
      selectedEntityIds: [s.id],
    }))
    .attach(
      memoEval(
        s => [s.id, s.$isOneWingDoorCabinet],
        (id, $isOneWingDoorCabinet) => ({
          page: $isOneWingDoorCabinet ? <AdjustableDoorWallItemPropertyPage id={id} /> : null,
        })
      )
    ),
]
